import styled from 'styled-components';

import { H4Styles } from './font-styles';

const H4 = styled.h4`
  ${H4Styles};
`;

export { H4 };
